'use strict';

var formValidation = require('../components/formValidation');
var createErrorNotification = require('@sfra/components/errorNotification');
var cache = {};

module.exports = {
    login: function () {
        $('form.login').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            form.spinner().start();
            $('form.login').trigger('login:submit', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        formValidation(form, data);
                        $('form.login').trigger('login:error', data);
                    } else {
                        $('form.login').trigger('login:success', data);
                        location.href = data.redirectUrl;
                    }
                },
                error: function (data) {
                    if (data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    } else {
                        $('form.login').trigger('login:error', data);
                        form.spinner().stop();
                    }
                }
            });
            return false;
        });
    },

    register: function () {
        $('form.registration').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            form.spinner().start();
            $('form.registration').trigger('login:register', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        $('form.registration').trigger('login:register:error', data);
                        formValidation(form, data);
                    } else {
                        $('form.registration').trigger('login:register:success', data);

                        if ($('#add-to-email-list').is(':checked')) {
                            $('body').trigger('emailSubscribe:done');
                        }

                        location.href = data.redirectUrl;
                    }
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification($('.error-messaging'), err.responseJSON.errorMessage);
                    }

                    form.spinner().stop();
                }
            });
            return false;
        });
    },

    resetPassword: function () {
        $('.reset-password-form').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            form.spinner().start();
            $('.reset-password-form').trigger('login:register', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        formValidation(form, data);
                    } else {
                        $('.request-password-title').text(data.receivedMsgHeading);
                        $('.request-password-body').empty()
                            .append('<p class="mb-2">' + data.receivedMsgBody + '</p>');
                        if (!data.mobile) {
                            $('#submitEmailButton').text(data.buttonText)
                                .attr('data-dismiss', 'modal');
                        } else {
                            $('.send-email-btn').empty()
                                .html('<a href="'
                                    + data.returnUrl
                                    + '" class="btn btn-primary btn-block">'
                                    + data.buttonText + '</a>'
                                );
                        }
                    }
                },
                error: function () {
                    form.spinner().stop();
                }
            });
            return false;
        });
    },

    clearResetForm: function () {
        $('#login .modal').on('hidden.bs.modal', function () {
            $('#reset-password-email').val('');
            $('.modal-dialog .form-control.is-invalid').removeClass('is-invalid');
        });
    },

    initCache: function () {
        cache.$newPasswordInput = $('.new-password-input').first();
        cache.$passwordRules = $('.password-rules-container');
        cache.loginSection = $('.checkout-login');
        cache.loginSectionContent = $('.checkout-login__content');
        cache.loginSectionPswField = $('.checkout-login__password-field');
        cache.loginSectionPswFieldIcon = $('.checkout-login__password-field-switch-cta-icon');
    },

    slidePasswordRules: function () {
        cache.$newPasswordInput.on('focus', function () {
            cache.$passwordRules.slideDown(300);
        });
        cache.$newPasswordInput.on('focusout', function () {
            cache.$passwordRules.slideUp(300);
        });
        $(document).on('keydown', function (e) {
            if (e.keyCode === 27) {
                cache.$passwordRules.hide();
            }
        });
    },

    toggleCheckoutLoginContent() {
        $(document).on('click', '.checkout-login__toggle-cta', function () {
            cache.loginSection.toggleClass('checkout-login--expanded').attr('aria-expanded', function (_, attr) {
                return attr === 'true' ? 'false' : 'true';
            });
            cache.loginSectionContent.slideToggle();
        });
    },

    togglePasswordVisibility() {
        $(document).on('click', '.checkout-login__password-field-switch-cta', function () {
            const isPswVisible = cache.loginSectionPswField.attr('type') === 'text';

            cache.loginSectionPswField.attr('type', isPswVisible ? 'password' : 'text');
            cache.loginSectionPswFieldIcon.toggleClass('fa-eye fa-eye-slash');

        });
    }
};
